import React from "react";
import { useTheme } from "@mui/material/styles";

const BroadcastIcon = () => {
  const theme = useTheme();
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_broadcast)">
        <circle
          cx="24"
          cy="24"
          r="23.5"
          fill={theme.palette.tertiary[100]}
          stroke={theme.palette.tertiary[300]}
        />
        <path
          d="M28.2427 17.7573C30.5858 20.1005 30.5858 23.8995 28.2427 26.2426M19.7573 26.2426C17.4142 23.8995 17.4142 20.1005 19.7573 17.7573M16.9287 29.0711C13.0234 25.1658 13.0234 18.8342 16.9287 14.929M31.0713 14.929C34.9765 18.8342 34.9765 25.1658 31.0713 29.0711"
          stroke={theme.palette.error[400]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24 24C25.1046 24 26 23.1046 26 22C26 20.8954 25.1046 20 24 20C22.8954 20 22 20.8954 22 22C22 23.1046 22.8954 24 24 24Z"
          fill={theme.palette.secondary[400]}
        />
        <path
          d="M24 24C25.1046 24 26 23.1046 26 22C26 20.8954 25.1046 20 24 20C22.8954 20 22 20.8954 22 22C22 23.1046 22.8954 24 24 24ZM24 24V33"
          stroke={theme.palette.primary[500]}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_broadcast">
          <rect width="48" height="48" fill={theme.palette.system[0]} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BroadcastIcon;
